module.exports = __webpack_public_path__ + "img/banner.d6e899a1.png";